import { render, staticRenderFns } from "./Petitionerdetails.vue?vue&type=template&id=e9ac6002&"
import script from "./Petitionerdetails.vue?vue&type=script&lang=js&"
export * from "./Petitionerdetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports